import React from "react";
import { Nav } from "./navbar/nav";

export default function Header({ image, title }) {
  return (
    <div>
      <div
        className="flex flex-col mb-14 relative bg-center bg-cover bg-no-repeat h-[50vh] sm:h-[50vh] md:h-[66vh] lg:h-[70vh]"
        style={{ backgroundImage: `url(${image})` }}
      >
        <div className="relative">
          <Nav />
        </div>

        <svg
          className="absolute bottom-[-1%]  md:bottom-[-5%] lg:bottom-[-9%]  left-0 w-full h-auto"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 320"
          preserveAspectRatio="none"
        >
          <path
            className="white"
            fill="#fff"
            fillOpacity="1"
            d="M0,224L60,213.3C120,203,240,181,360,186.7C480,192,600,224,720,245.3C840,267,960,277,1080,250.7C1200,224,1300,170,1380,140L1440,120L1440,320L1380,320C1300,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
          ></path>
        </svg>
      </div>

      <div className="h-[50%] flex items-center justify-center">
          <h1 className="text-center lg:text-balance relative text-black text-4xl  sm:text-5xl  md:text-6xl lg:text-5xl mb-14 sm:mb-16 md:mb-20 lg:mb-14 custom-font " style={{ textShadow: "4px 4px 5px #fff" , fontWeight: '800' }}>
            {title}
          </h1>
        </div>
    </div>
  );
}